<template>
  <div class="root-body">
    <div class="col-md-1 menu-div">
      <div class="apply-button">
        <button class="btn btn-link" @click="fetchDataBasedOnFilter()">
          APPLY
        </button>
      </div>
      <div class="registration-toggle">
        <span class="registration-toggle-title">REGISTRATION</span>
        <span class="toggler">
          <label class="switch">
            <input
              v-model="registrationToggle"
              value="!registrationToggle"
              type="checkbox"
              checked
            />
            <span class="slider round"></span>
          </label>
        </span>
      </div>
      <div class="accordion" id="accordion">
        <div class="card">
          <div class="card-header" id="headingOne">
            <button
              class="btn btn-link"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Client filters
            </button>
          </div>

          <div
            id="collapseOne"
            class="collapse"
            aria-labelledby="headingOne"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in clientFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeDataFilter($event, 'client')"
                      type="radio"
                      name="clientFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingTwo">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              tiers
            </button>
          </div>
          <div
            id="collapseTwo"
            class="collapse"
            aria-labelledby="headingTwo"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in tierFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeDataFilter($event, 'tier')"
                      type="radio"
                      name="tierFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingThree">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              campaigns
            </button>
          </div>
          <div
            id="collapseThree"
            class="collapse"
            aria-labelledby="headingThree"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in campaignFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeDataFilter($event, 'campaign')"
                      type="radio"
                      name="campaignFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingFour">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              data-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Devices
            </button>
          </div>
          <div
            id="collapseFour"
            class="collapse"
            aria-labelledby="headingFour"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in deviceFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeDataFilter($event, 'device')"
                      type="radio"
                      name="deviceFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingSix">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              data-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              Users
            </button>
          </div>
          <div
            id="collapseSix"
            class="collapse"
            aria-labelledby="headingSix"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in userFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeDataFilter($event, 'user')"
                      type="radio"
                      name="userFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-header" id="headingSeven">
            <button
              class="btn btn-link collapsed"
              data-toggle="collapse"
              data-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              Time Frames
            </button>
          </div>
          <div
            id="collapseSeven"
            class="collapse"
            aria-labelledby="headingSeven"
            data-parent="#accordion"
          >
            <div class="card-body">
              <div class="filter-group">
                <div v-for="filter in timeFrameFilters" :key="filter.id">
                  <div class="radio-input">
                    <input
                      @click="changeDataFilter($event, 'time')"
                      type="radio"
                      name="timeFilters"
                      :id="filter.id"
                      :value="filter.id"
                      checked
                    />
                    <label :for="filter.id">{{ filter.name }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-11 root-body table-body">
      <div class="loader-div" v-if="totalStatsBusy">
        <!--        <loader :size="'8px'"></loader>-->
        <span class="insteadLoader"
          >CREATING REPORT ,PLEASE WAIT
          <div class="snippet" data-title=".dot-flashing">
            <div class="stage">
              <div class="dot-flashing"></div>
            </div>
          </div>
        </span>
      </div>
      <div
        class="total-stats-table"
        v-if="
          totalStats['reports'] &&
            totalStats['reports'].length > 0 &&
            !totalStatsBusy
        "
      >
        <table id="total-stats">
          <thead>
            <tr>
              <td></td>
              <td>{{ totalStats["total"].total }}</td>
              <td>{{ totalStats["total"].not_reached }}</td>
              <td>{{ totalStats["total"].not_interested }}</td>
              <td>{{ totalStats["total"].bad_number }}</td>
              <td>{{ totalStats["total"].not_usable }}</td>
              <td>{{ totalStats["total"].ended }}</td>
              <td>{{ totalStats["total"].deposited_clients }}</td>
              <td>{{ totalStats["total"].deposits }}</td>
              <td>{{ totalStats["total"].marketing_cost }}</td>
              <td>{{ totalStats["total"].employees_cost }}</td>
              <td>{{ totalStats["total"].total_expenses }}</td>
              <td>{{ totalStats["total"].total_profit }}</td>
              <td>{{ totalStats["total"].merged }}</td>
              <td>{{ totalStats["total"].no_answer }}</td>
              <td>{{ totalStats["total"].scheduled_calls }}</td>
              <td>{{ totalStats["total"].transfer_live }}</td>
              <td>{{ totalStats["total"].transfer_online }}</td>
              <td>{{ totalStats["total"].leads }}</td>
              <td>{{ totalStats["total"].c2c }}</td>
              <td>{{ totalStats["total"].call_time }}</td>
              <td>{{ totalStats["total"].t1 }}</td>
              <td>{{ totalStats["total"].t2 }}</td>
              <td>{{ totalStats["total"].t3 }}</td>
              <td>{{ totalStats["total"].t1_transfer_live }}</td>
              <td>{{ totalStats["total"].t1_transfer_online }}</td>
              <td>{{ totalStats["total"].t2_transfer_live }}</td>
              <td>{{ totalStats["total"].t2_transfer_online }}</td>
              <td>{{ totalStats["total"].t3_transfer_live }}</td>
              <td>{{ totalStats["total"].t3_transfer_online }}</td>
            </tr>
            <tr>
              <th>
                Date
                <button
                  v-on:click="applySorting(0, 0)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-alpha-down': sortOrder[0] === 'asc',
                      'fas fa-sort-alpha-up': sortOrder[0] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                Total
                <button
                  v-on:click="applySorting(1, 1)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                NR
                <button
                  v-on:click="applySorting(1, 2)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                NI
                <button
                  v-on:click="applySorting(1, 3)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                BN
                <button
                  v-on:click="applySorting(1, 4)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                NU
                <button
                  v-on:click="applySorting(1, 5)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                ENDED
                <button
                  v-on:click="applySorting(1, 6)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                DEP CLIENTS
                <button
                  v-on:click="applySorting(1, 7)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                DEPOSITS
                <button
                  v-on:click="applySorting(1, 8)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                Marketing Cost
                <button
                  v-on:click="applySorting(1, 9)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                Employees Cost
                <button
                  v-on:click="applySorting(1, 10)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                Total Expenses
                <button
                  v-on:click="applySorting(1, 11)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                Total Profit
                <button
                  v-on:click="applySorting(1, 12)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                MERGED
                <button
                  v-on:click="applySorting(1, 13)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                NA
                <button
                  v-on:click="applySorting(1, 14)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                CA
                <button
                  v-on:click="applySorting(1, 15)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                TR-LV
                <button
                  v-on:click="applySorting(1, 16)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                TR-ON
                <button
                  v-on:click="applySorting(1, 17)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                LD
                <button
                  v-on:click="applySorting(1, 18)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                C2C
                <button
                  v-on:click="applySorting(1, 19)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                Total Calls Time
                <button
                  v-on:click="applySorting(1, 20)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T1
                <button
                  v-on:click="applySorting(1, 21)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T2
                <button
                  v-on:click="applySorting(1, 22)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T3
                <button
                  v-on:click="applySorting(1, 23)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T1_TR_LV
                <button
                  v-on:click="applySorting(1, 24)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T1_TR_ON
                <button
                  v-on:click="applySorting(1, 25)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T2_TR_LV
                <button
                  v-on:click="applySorting(1, 26)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T2_TR_ON
                <button
                  v-on:click="applySorting(1, 27)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T3_TR_LV
                <button
                  v-on:click="applySorting(1, 28)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
              <th>
                T3_TR_ON
                <button
                  v-on:click="applySorting(1, 29)"
                  class="btn btn-default btn-sm override"
                >
                  <span
                    class="fa"
                    :class="{
                      'fas fa-sort-numeric-down': sortOrder[1] === 'asc',
                      'fas fa-sort-numeric-up': sortOrder[1] === 'desc'
                    }"
                  ></span>
                </button>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in totalStats['reports']" v-bind:key="data">
              <td>{{ data.date }}</td>
              <td>{{ data.report.total }}</td>
              <td>{{ data.report.not_reached }}</td>
              <td>{{ data.report.not_interested }}</td>
              <td>{{ data.report.bad_number }}</td>
              <td>{{ data.report.not_usable }}</td>
              <td>{{ data.report.ended }}</td>
              <td>{{ data.report.deposited_clients }}</td>
              <td>{{ data.report.deposits }}</td>
              <td>{{ data.report.marketing_cost }}</td>
              <td>{{ data.report.employees_cost }}</td>
              <td>{{ data.report.total_expenses }}</td>
              <td>{{ data.report.total_profit }}</td>
              <td>{{ data.report.merged }}</td>
              <td>{{ data.report.no_answer }}</td>
              <td>{{ data.report.scheduled_calls }}</td>
              <td>{{ data.report.transfer_live }}</td>
              <td>{{ data.report.transfer_online }}</td>
              <td>{{ data.report.leads }}</td>
              <td>{{ data.report.c2c }}</td>
              <td>{{ data.report.call_time }}</td>
              <td>{{ data.report.t1 }}</td>
              <td>{{ data.report.t2 }}</td>
              <td>{{ data.report.t3 }}</td>
              <td>{{ data.report.t1_transfer_live }}</td>
              <td>{{ data.report.t1_transfer_online }}</td>
              <td>{{ data.report.t2_transfer_live }}</td>
              <td>{{ data.report.t2_transfer_online }}</td>
              <td>{{ data.report.t3_transfer_live }}</td>
              <td>{{ data.report.t3_transfer_online }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
import Loader from "../../../../main/misc.main/loader/Loader";
import apiClientCreator from "../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../mixins/user/auth/UsersPermissionCheck";

export default {
  name: "TotalStats.container.vue",
  // components: { Loader },
  mixins: [UsersPermissionCheck],

  data() {
    return {
      totalStats: [],
      rawStats: [],
      registrationToggle: false,
      totalStatsBusy: false,
      currentTimeFrame: "D",
      sortOrder: {
        0: "desc",
        1: "desc"
      },
      clientFilters: [
        {
          id: 0,
          name: "REG"
        },
        {
          id: 1,
          name: "DUP"
        },
        {
          id: "all",
          name: "ALL"
        }
      ],
      tierFilters: [
        {
          id: 1,
          name: "T1"
        },
        {
          id: 2,
          name: "T2"
        },
        {
          id: 3,
          name: "T3"
        },
        {
          id: "all",
          name: "ALL"
        }
      ],
      deviceFilters: [
        {
          id: "c",
          name: "Computer"
        },
        {
          id: "m",
          name: "Mobile"
        },
        {
          id: "all",
          name: "ALL"
        }
      ],
      timeFrameFilters: [
        {
          id: "Y",
          name: "Yearly"
        },
        {
          id: "M",
          name: "Monthly"
        },
        {
          id: "W",
          name: "Weekly"
        },
        {
          id: "D",
          name: "Daily"
        }
      ],
      campaignFilters: [
        {
          id: "google",
          name: "Google"
        },
        {
          id: "bing",
          name: "Bing"
        },
        {
          id: "app",
          name: "Application"
        },
        {
          id: "seo",
          name: "SEO"
        },
        {
          id: "push",
          name: "Push"
        },
        {
          id: "email",
          name: "Email"
        },
        {
          id: "video",
          name: "Video"
        },
        {
          id: "facebook",
          name: "Facebook"
        },
        {
          id: "affiliate",
          name: "Affiliate"
        },
        {
          id: "all",
          name: "ALL"
        }
      ],
      userFilters: [],
      queryFilters: {
        client: "all",
        tier: "all",
        device: "all",
        time: "D",
        campaign: "all",
        user: "all",
        registration: false
      }
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [ "dictionaries", "salesPersonList"])
  },
  created() {
    this.assignFilterAgents();
    this.fetchDataBasedOnFilter();
  },
  methods: {
    changeDataFilter(event, queryGroup) {
      this.queryFilters[queryGroup] = event.target.value;
    },
    /**
     * Upon component creation get all the users
     * that are relevant for the data filtering
     */
    assignFilterAgents() {
      this.salesPersonList.forEach(user => {
        // Get only agents with role 7
        if (user.role === 7) {
          // Add each user as a filtering option
          let item = {
            id: user.id,
            name: user.full_name
          };
          this.userFilters.push(item);
        }
      });
      // Add the overall filter option to the filters array
      this.addAllFilterOption(this.userFilters);
    },
    /**
     * Fetches the data based on the filters that were
     * chosen in the accordion menu
     */
    async fetchDataBasedOnFilter() {
      if (this.CheckUserPermission([1, 2, 3, 4, 12])) {
        try {
          this.totalStatsBusy = true;
          this.queryFilters["registration"] = this.registrationToggle;
          const res = await apiClientCreator(
            `reports/total_stats/filter/data`
          ).get("", { params: this.queryFilters });
          this.totalStats = res.data;
          // this.rawData = res.data;
          this.currentTimeFrame = this.queryFilters.time;
          this.totalStatsBusy = false;
        } catch (e) {}
      }
    },
    applyFiltersToRawData() {
      let clientFilter = this.clientFilters.find(item => {
        return item.id === this.queryFilters.client;
      }).name;
      let tierFilter = this.clientFilters.find(item => {
        return item.id === this.queryFilters.tier;
      }).name;
      let deviceFilter = this.clientFilters.find(item => {
        return item.id === this.queryFilters.device;
      }).name;
      // Assign the raw stats section to the total stats that will be visible to the user
      this.totalStats = this.rawData[this.queryFilters.time][clientFilter][
        "TIERS"
      ][tierFilter]["CAMPAIGNS"][this.queryFilters.campaign]["DEVICES"][
        deviceFilter
      ]["USERS"][this.queryFilters.user];
    },
    /**
     * Add the overall filter option to the provided filters array
     * @param arrayFilter The array of filer for whom we wish to add the 'all' option
     */
    addAllFilterOption(arrayFilter) {
      let allItem = {
        id: "ALL",
        name: "ALL"
      };
      arrayFilter.push(allItem);
    },
    /**
     * Sort a specific column in a specific table by type
     *
     * @param typeSort - the sort type (numeric or alphabetic)
     * @param tableColumn - the table column we wish to sort
     * @param tableId - the id of the table we wish to sort
     */
    applySorting(typeSort, tableColumn) {
      let table,
        rows,
        switching,
        i,
        x,
        y,
        shouldSwitch,
        switchcount = 0;
      table = document.getElementById("total-stats");
      switching = true;
      this.sortOrder[typeSort] = "desc";
      while (switching) {
        switching = false;
        rows = table.rows;
        for (i = 2; i < rows.length - 1; i++) {
          shouldSwitch = false;
          x = rows[i].getElementsByTagName("TD")[tableColumn];
          y = rows[i + 1].getElementsByTagName("TD")[tableColumn];
          if (this.sortOrder[typeSort] === "desc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) < Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          } else if (this.sortOrder[typeSort] === "asc") {
            if (typeSort === 0) {
              if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                shouldSwitch = true;
                break;
              }
            } else {
              if (Number(x.innerHTML) > Number(y.innerHTML)) {
                shouldSwitch = true;
                break;
              }
            }
          }
        }
        if (shouldSwitch) {
          rows[i].parentNode.insertBefore(rows[i + 1], rows[i]);
          switching = true;
          switchcount++;
        } else {
          if (switchcount === 0 && this.sortOrder[typeSort] === "desc") {
            this.sortOrder[typeSort] = "asc";
            switching = true;
          }
        }
      }
    }
  }
};
</script>

<style scoped>
table tr:nth-of-type(2n + 1) {
  background: #f5f7ff;
}
table tr:hover {
  background: #eceff1;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 0.5em 0.4em;
}
th {
  font-size: smaller;
}
.btn-link {
  width: 100%;
  color: #fff;
  background-color: #337ab7;
  border-color: #2e6da4;
}
.btn-link,
.btn-link:hover,
.btn-link:focus {
  text-decoration: none;
  outline: none;
}
input[type="radio"] {
  margin: 3px 5px 0;
}

.radio-input {
  display: flex;
  font-size: 0.7vw;
  background-color: lightgrey;
  border: 1px solid grey;
  border-top: none;
}
.apply-button {
  padding: 2em 0;
}
.total-stats-table {
  padding: 1em 0;
  font-size: 11px;
  text-align: center;
}
.btn-sm {
  padding: 0 1px 3px 0;
  font-size: 0.7vw;
  line-height: 1.5;
  border: none;
}
.btn-sm:active {
  border: none;
  outline: none;
  background: #e0e0e0;
}
.btn-sm:focus {
  border: none;
  outline: none;
}
.loader-div {
  padding: 7em;
}
.root-body {
  max-width: 1730px;
  display: flex;
}
.table-body {
  background-color: #fff;
  border-radius: 15px;
  border: #e5e5e5 1px solid;
}
.menu-div {
  border-radius: 15px;
  background-color: #fff;
  margin-left: 80px;
  border: #e5e5e5 1px solid;
}
.accordion {
  margin-bottom: 18px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 15px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 9px;
  width: 9px;
  left: 2px;
  bottom: 3px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.registration-toggle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.registration-toggle-title {
  font-size: 9px;
}
.toggler {
  padding-right: 0.5em;
}

/**
 * ==============================================
 * Dot Flashing
 * ==============================================
 */
.dot-flashing {
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
}

.dot-flashing::before {
  left: -15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 0s;
}

.dot-flashing::after {
  left: 15px;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: red;
  color: red;
  animation: dotFlashing 1s infinite alternate;
  animation-delay: 1s;
}

@keyframes dotFlashing {
  0% {
    background-color: red;
  }
  50%,
  100% {
    background-color: #ebe6ff;
  }
}
.stage {
  position: absolute;
  left: 110%;
  top: 48%;
}
.insteadLoader {
  color: red;
  position: absolute;
  left: 35%;
  top: 158px;
}
</style>
